import { StyleSheet } from '@react-pdf/renderer';

export let pdfStyles = () =>
  StyleSheet.create({
    viewPadding: {
      paddingHorizontal: 6,
    },
    textBox: {
      fontSize: 10,
      textAlign: 'left',
      fontFamily: 'Red Hat Display',
      backgroundColor: '#f0ebdd',
      height: '100%',
      paddingHorizontal: 5,
    },
  });

export const primaryColorDark = '#163B3F';
export const primaryColorLight = '#47b7d1';
export const lightInputTextFieldColor = '#e4f3fa';

export const textBoxFontFamily = 'Red Hat Display';
export const textBoxFontSize = 13;
